import { pushToDataLayer } from '@domain-group/fe-helper';
import { getGa4PageProps, getGa4UserProps } from '../utils';

export interface SearchResultsViewGa4Props {
  agentIds?: number[];
  agencyIds?: number[];
  searchTerm?: string;
  searchType?: 'Sell' | 'Lease';
  searchSortBy?: string;
  searchResultCount?: number;
  searchResultsDepth?: number;
  suburbNames?: string[];
  postcodes?: string[];
}

const join = (values: Array<string | number> = []): string => values.join(',');

const trackSearchResultsViewGa4 = ({
  agentIds = [],
  agencyIds = [],
  suburbNames = [],
  postcodes = [],
  searchTerm = '',
  searchType = 'Sell',
  searchSortBy = '',
  searchResultCount,
  searchResultsDepth,
}: SearchResultsViewGa4Props = {}): void => {
  pushToDataLayer({
    event: 'search_results_view',
    event_parameters: {
      agency_agent_id: '',
      agency_agent_name: '',
      agency_id: '',
      agency_name: '',
      ...getGa4PageProps(),
      search_loc_category: 'suburb',
      search_loc_postcodes: join(postcodes),
      search_loc_suburb: join(suburbNames),
      search_results_agency_ids: join(agencyIds),
      search_results_agent_ids: join(agentIds),
      search_result_count: searchResultCount ?? '',
      search_results_depth: searchResultsDepth ?? '',
      search_results_position: '',
      search_sort_by: searchSortBy,
      search_term: searchTerm,
      search_type: searchType,
    },
    user_properties: getGa4UserProps(),
  });
};

export default trackSearchResultsViewGa4;
